import React from 'react';
import type { FC, PropsWithChildren } from 'react';
import { InputsSection, InputBox, ModalButtons, ModalForm, Modal, SelectBox, TextArea } from '../../../src/components/Modal';
import ModalHeading from '../../../src/components/Modal/ModalHeading';
import AddUserSkeleton from '../../../src/Skeletons/AddUserSkeleton';
import { IRTMTimeLogNew } from '../../hooks/rtm_time_log/index.type';
import TextBox from '../../../src/components/Modal/InputBox/TextBox.module.css';

export type AddEditModalState = PropsWithChildren<{
    status: boolean;
    data?: IRTMTimeLogNew;
}>;

export type IaddEditModalStates = PropsWithChildren<{
    description: { value: string; error: string };
    duration: { value: string; error: string };
    customDuration: { value: string; error: string };
}>;

type AddEditModalProps = PropsWithChildren<{
    loading: boolean;
    addEditModal: AddEditModalState;
    onCloseModal?: () => void;
    handleAddEdit?: (event: React.FormEvent<HTMLFormElement>) => void;
    addEditModalStates: IaddEditModalStates;
    setAddEditModalStates: React.Dispatch<React.SetStateAction<IaddEditModalStates>>;
}>;

const AddEditModal: FC<AddEditModalProps> = props => {

    const isCustomDuration = props.addEditModalStates.duration.value === 'Custom';
    
    return (
        <Modal show={props.addEditModal.status}>
            <ModalHeading heading={props.addEditModal.data && props.addEditModal.data._id ? 'Update RTM Time Log' : 'Add RTM Time Log'} />
            {props.loading ? (
                <AddUserSkeleton />
            ) : (
                <ModalForm style={{ marginBottom: '2.5rem' }} onSubmit={props.handleAddEdit}>
                    <InputsSection>
                        <TextArea
                            label='Description'
                            placeholder='Description Here'
                            value={props.addEditModalStates.description.value}
                            onChange={event => {
                                props.setAddEditModalStates(prevVal => ({ ...prevVal, description: { value: event.target.value, error: '' } }));
                            }}
                            errorMessage={props.addEditModalStates.description.error}
                            style={{ width: '52rem' }}
                        />
                    </InputsSection>
                    <p className={TextBox.form_input__label} style={{ marginBottom: "5px" }}>Duration</p>
                    <InputsSection>
                        <SelectBox
                            label=''
                            value={props.addEditModalStates.duration.value}
                            inputContainerStyle={{ width: '25rem' }}
                            onChange={event => {
                                props.setAddEditModalStates(prevVal => ({ ...prevVal, duration: { value: event.target.value, error: '' } }));
                            }}
                            errorMessage={props.addEditModalStates.duration.error}
                        >
                            <option value=''>Select Duration Here</option>
                            <option value='60'>1 hours</option>
                            <option value='120'>2 hours</option>
                            <option value='180'>3 hours</option>
                            <option value='240'>4 hours</option>
                            <option value='Custom'>Custom</option>
                        </SelectBox>

                        {isCustomDuration && (
                            <InputBox
                                label=''
                                placeholder='Enter duration in minutes'
                                value={props.addEditModalStates.customDuration.value}
                                onChange={event => {
                                    props.setAddEditModalStates(prevVal => ({ ...prevVal, customDuration: { value: event.target.value, error: '' } }));
                                }}
                                errorMessage={props.addEditModalStates.customDuration.error}
                            />
                        )}
                    </InputsSection>

                    <ModalButtons
                        submitButtonLabel={props.addEditModal.data && props.addEditModal.data._id ? 'Update' : 'Add'}
                        cancelButtonLabel='Cancel'
                        onCancel={props.onCloseModal}
                    />
                </ModalForm>
            )}
        </Modal>
    );
};

export default AddEditModal;